/**
 * Single switch for the AI "Overall Progress & Trends" draft: the "Generate
 * with AI" button in the card header and the ⚠️ AI-generated-draft warning
 * above the notes field. They are two halves of one feature, so they read one
 * flag rather than each repeating an env check that can drift.
 *
 * ON HOLD as of 2026-08-10 — hidden EVERYWHERE, local dev included, not just
 * the deployed builds. The Bedrock summary still needs research validation and
 * a backend deploy before any practitioner should see it, so the UI stays out
 * of sight until the feature is ready to implement for real.
 *
 * Modeled on bwhLabsVisible() in supplementsVisibility.ts, which holds a
 * feature back the same way. A gate rather than commented-out code so
 * onGenerateSummary(), the prompt and buildAIExportData keep compiling and
 * cannot rot.
 *
 * TO LAUNCH: return `process.env.REACT_APP_ENV !== 'prod' && process.env
 * .REACT_APP_ENV !== 'slava'` to restore the previous dev-only behavior, or
 * delete this function and its call sites once the feature ships everywhere.
 */
export function aiProgressSummaryVisible(): boolean {
  return false;
}
